var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCrossicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.53557 5.94975L0.292934 10.1924C-0.09759 10.5829 -0.09759 11.2161 0.292934 11.6066C0.683458 11.9971 1.31662 11.9971 1.70715 11.6066L5.94979 7.36396L10.1924 11.6066C10.583 11.9971 11.2161 11.9971 11.6066 11.6066C11.9972 11.2161 11.9972 10.5829 11.6066 10.1924L7.364 5.94975L11.6066 1.70711C11.9972 1.31658 11.9972 0.683418 11.6066 0.292894C11.2161 -0.0976307 10.583 -0.0976305 10.1924 0.292893L5.94979 4.53553L1.70715 0.292893C1.31662 -0.0976313 0.683457 -0.0976317 0.292932 0.292893C-0.0975914 0.683417 -0.0975915 1.31658 0.292932 1.70711L4.53557 5.94975Z",
    fill: "#535F79"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCrossicon);
export default __webpack_public_path__ + "static/media/crossicon.f38f92c68cc4d8b62bd21dc0fdbb2d4b.svg";
export { ForwardRef as ReactComponent };